import {BehaviorSubject, map} from 'rxjs';
import {ThemeType} from '@px/enum';
import {globalStorage} from '@px/storage/global';
import {authStatus$} from './auth';
import {preference$, updatePreference} from './preference';

export const theme$ = new BehaviorSubject<ThemeType>(globalStorage.readGlobalStorage().themeType);

export const isDark$ = theme$.pipe(map((theme) => theme === ThemeType.Dark));

preference$.subscribe((preference: Preference) => {
  if (preference.hasOwnProperty('darkTheme')) {
    theme$.next(preference.darkTheme ? ThemeType.Dark : ThemeType.Light);
  }
});

theme$.subscribe((theme: ThemeType) => {
  const {classList} = document.body;
  classList.add(theme === ThemeType.Light ? 'light' : 'dark');
  classList.remove(theme === ThemeType.Dark ? 'light' : 'dark');
  globalStorage.updateGlobalStorage({themeType: theme});
  if (authStatus$.getValue() !== 'Login') {
    return;
  }
  const {darkTheme} = preference$.getValue();
  if (darkTheme === undefined) {
    return;
  }
  if (darkTheme && theme === ThemeType.Dark) {
    return;
  }
  if (!darkTheme && theme === ThemeType.Light) {
    return;
  }
  updatePreference('darkTheme', theme === ThemeType.Dark).then();
});
